export const setUserLoading = (state, payload) => {
    state.isLoadingAuth = payload;
};

export const setUser = (state, payload) => {
    state.user = payload;
};
